export const roundToTwoDecimalPlace = (num) => {
  if (num < 0) {
    num = 0 - num;
  }
  const stringNum = num + "";
  const stringNumArr = stringNum.split(".");
  if (stringNumArr.length === 1) {
    return `${stringNum}.00`;
  }
  const value = stringNumArr[0];
  const decimal = stringNumArr[1];
  let newValue = value;
  if (decimal.length === 2) {
    return `${newValue}.${decimal}`;
  } else if (decimal.length < 2) {
    return `${newValue}.${decimal}0`;
  } else {
    return `${newValue}.${decimal.slice(0, 2)}`;
  }
};
